import { DIVERGENCE_PANEL_URL } from '@/config';

function getDivergencesPanelLink() {
  const accessToken = sessionStorage.getItem('accessToken');
  const tokenType = sessionStorage.getItem('tokenType');

  window.location.href = `${DIVERGENCE_PANEL_URL}#access_token=${accessToken}&token_type=${tokenType}&expires_in=`;
}

export default getDivergencesPanelLink;
